<template>
  <div class="footer-box">
    <div class="foot-box w-100" style="position: relative;z-index: 1;">
      <div class="w-1500">
        <ul class="between-center dkhs-box">
          <li>
            <!-- <div class="circle">多</div>
            <p>
              反应快 报价快<br />
              出库快 处理快
            </p> -->
            <img src="../assets/foot-icon/duo.png" alt="" />
            <div class="right">
              <div class="labels">多</div>
              <p>行业产品多 生产基地多<br />库存储备多</p>
            </div>
          </li>
          <li>
            <!-- <div class="circle">快</div>
            <p>
              <span class="text">多领域行业产品 多区域生产基地</span><br />
              多库存储备 多知识产权
            </p> -->
            <img src="../assets/foot-icon/kuai.png" alt="" />
            <div class="right">
              <div class="labels">快</div>
              <p>反应快 报价快<br />出库快 处理快</p>
            </div>
          </li>
          <li>
            <!-- <div class="circle">好</div>
            <p>
              专注开发自动化输送设备零部件产业链产品3d<br />模型库；<br />
              专家 销售代表全程辅助设计，助力选型无忧；<br />
              专业部门全程售前、售后支持、技术职称。
            </p> -->
            <img src="../assets/foot-icon/hao.png" alt="" />
            <div class="right">
              <div class="labels">好</div>
              <p>品质好 价格好<br />服务好 专业好</p>
            </div>
          </li>
          <li>
            <!-- <div class="circle">省</div>
            <p>
              精选各行业优秀案例、助力设计参与甄选；<br />
              精准替换同行业相同功能零部件，功能保证；<br />
              精密专用加工设备，质量保证。
            </p> -->
            <img src="../assets/foot-icon/sheng.png" alt="" />
            <div class="right">
              <div class="labels">省</div>
              <p>省成本 省库存<br />省精力 省运费</p>
            </div>
          </li>
        </ul>
        <ul class="between-center dkhs-box line">
          <li>
            <!-- <div class="circle">专</div>
            <p>
              品质好 价格好<br />
              服务好 专业好
            </p> -->
            <img src="../assets/foot-icon/zhuan.png" alt="" />
            <div class="right">
              <div class="labels">专</div>
              <p>专家辅助设计，助力选型<br />专业流程支持，技术服务</p>
            </div>
          </li>
          <li>
            <!-- <div class="circle">精</div>
            <p>
              <span class="text">省成本 省库存</span><br />
              省精力 省运费
            </p> -->
            <img src="../assets/foot-icon/jing.png" alt="" />
            <div class="right">
              <div class="labels">精</div>
              <p>精选行业案例，设计甄选<br />精准同业替换，性能保证</p>
            </div>
          </li>
          <li>
            <!-- <div class="circle">特</div>
            <p>
              更新行业产品持续为企业注入创新力；<br />
              革新经营管理模式为企业提供发展力；<br />
              创新商业模式为企业建立榕树生命力。
            </p> -->
            <img src="../assets/foot-icon/te.png" alt="" />
            <div class="right">
              <div class="labels">特</div>
              <p>特快专递，极速响应<br />特惠价格，超值服务</p>
            </div>
          </li>
          <li>
            <!-- <div class="circle">新</div>
            <p>
              特别针对系统化、模块化产品形成标准化产品库；<br />
              特殊线上线下公开透明售价系统；<br />
              独特替客户开发研制新产品方案，保密销售。
            </p> -->
            <img src="../assets/foot-icon/xin.png" alt="" />
            <div class="right">
              <div class="labels">新</div>
              <p>替客开发新品，保密销售<br />系统化模块化，透明售价</p>
            </div>
          </li>
        </ul>
        <!-- <ul class="between-center dkhs-box">
          <li>
            <img src="../assets/images/duo1.png" alt="" />
            <p>
              常规库存充足<br />
              涵盖行业专属产品<br />
              多区域实体仓储库
            </p>
          </li>
          <li>
            <img src="../assets/images/kuai1.png" alt="" />
            <p>
              反应快<br />
              报价快<br />
              急速出库
            </p>
          </li>
          <li>
            <img src="../assets/images/hao1.png" alt="" />
            <p>
              品质保障<br />
              金牌客服服务体系<br />
              降低成本优选合作伙伴
            </p>
          </li>
          <li>
            <img src="../assets/images/sheng1.png" alt="" />
            <p>
              免运费<br />
              无起订量<br />
              批量订货折上折<br />
              全产业链一站式采购
            </p>
          </li>
        </ul> -->
        <!-- <div class="home-box4 w-100"><a @click="navTo('多快好省')"><img src="../assets/images/dkhs.png"></a></div> -->
        <div class="top-box w-100 between-center">
          <div class="pull-left">
            <!-- <el-select v-model="listValue" placeholder="请选择" @change="elSelect">
							<el-option v-for="(item,index) in list" :key="item.name" :label="item.name" :value="index">
							</el-option>
						</el-select> -->
            <!-- <div class="lists">
              <template v-for="(item2, index2) in huanan">
                <div class="address-box">
                  <img src="../assets/images/icon_8.png" alt="" />
                  <span>{{ item2.name }}</span>
                </div>
                <p v-for="p in item2.child">{{ p }}</p>
              </template>
            </div>

            <div class="lists">
              <template v-for="(item2, index2) in huadong">
                <div class="address-box">
                  <img src="../assets/images/icon_8.png" alt="" />
                  <span>{{ item2.name }}</span>
                </div>
                <p v-for="p in item2.child">{{ p }}</p>
              </template>
            </div>
            <div class="lists">
              <template v-for="(item2, index2) in huabei">
                <div class="address-box">
                  <img src="../assets/images/icon_8.png" alt="" />
                  <span>{{ item2.name }}</span>
                </div>
                <p v-for="p in item2.child">{{ p }}</p>
              </template>
            </div>
            <div class="lists">
              <template v-for="(item2, index2) in xinan">
                <div class="address-box">
                  <img src="../assets/images/icon_8.png" alt="" />
                  <span>{{ item2.name }}</span>
                </div>
                <p v-for="p in item2.child">{{ p }}</p>
              </template>
            </div> -->

            <div class="relationList">
              <div v-for="(relation, relationId) in relationList" class="relation">
                <div class="relationArea">
                  <img src="../assets/images/icon_8.png" alt="" />
                  <span>{{ relation.area }}</span>
                </div>
                <div class="relationItem">
                  <p v-for="relationItem in relation.list">
                  <span v-if="relationItem.phone">
                    {{ relationItem.city }}：{{ relationItem.phone }} {{ relationItem.name }}
                  </span>
                  <span v-else>
                    邮箱：{{ relationItem.email }}
                  </span>
                </p>
                </div>
              </div>
            </div>
          </div>
          <div class="box-right">
            <div class="box1">
              <span style="color: #dfebf5">服务总机</span>
              <!-- <i>023-68617887</i> -->
              <i style="margin: 0.5rem 0;">023-68617887</i>
              <p style="color: #ccdeee; font-size: 0.8rem">
                工作时间:上午8:00~12:00下午13:30~17:45<br />(星期一~六,节假日除外)
              </p>
            </div>
            <div class="pull-right">
              <div class="box2 w-100">
                <img src="../assets/images/hlx_gzh.png" />
                <div class="label">汇利兴微信公众号</div>
              </div>
              <div class="box2 w-100">
                <img src="../assets/images/hxzz_gzh.png" />
                <div class="label">汇兴智造微信公众号</div>
              </div>
            </div>
          </div>
        </div>
        <div class="lower-box w-100">
          <div class="pull-left">
            版权所有©重庆汇利兴工业自动化设备有限公司2013-2014
            渝ICP备13005523号-8
          </div>
          <div class="pull-right" style="color: #7da0cc">
            <span>技术支持：天健世纪</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRelation } from '../common/http';

export default {
  data() {
    return {
      listIndex: 0,
      listValue: '华南区域',
      firstList: [
        {
          label: '多',
          value: ['反应快 报价快', '出库快 处理快']
        },
        {
          label: '快',
          value: ['多领域行业产品 多区域生产基地', '多库存储备 多知识产权']
        },
        {
          label: '好',
          value: [
            '专注开发自动化输送设备零部件产业链产品3d模型库；',
            '专家 销售代表全程辅助设计，助力选型无忧；',
            '专业部门全程售前、售后支持、技'
          ]
        },
        {
          label: '省',
          value: [
            '精选各行业优秀案例、助力设计参与甄选；',
            '精准替换同行业相同功能零部件，功能保证；',
            '精密专用加工设备，质量保证。'
          ]
        }
      ],
      secondList: [
        {
          label: '专',
          value: ['品质好 价格好', '服务好 专业好']
        },
        {
          label: '精',
          value: ['省成本 省库存', '省精力 省运费']
        },
        {
          label: '特',
          value: [
            '更新行业产品持续为企业注入创新力；',
            '革新经营管理模式为企业提供发展力；',
            '创新商业模式为企业建立榕树生命力'
          ]
        },
        {
          label: '新',
          value: [
            '特别针对系统化、模块化产品形成标准化产品库；',
            '特殊线上线下公开透明售价系统；',
            '独特替客户开发研制新产品方案，保密销售。'
          ]
        }
      ],
      huanan: [
        {
          name: '华南区域',
          child: [
            // "东莞：138 2691 8862 杨小姐",
            // "深圳：136 0029 9791 严先生",
            // "佛山：181 6980 1888 钟先生",
            // "中山：139 2681 0359 李先生",
            // "珠海：139 2571 2457 钟先生",
            // "广州：139 2926 6121 邓先生",
            // "惠州：139 2681 2291 曾先生"
            '莞深惠：139 2681 2001 陈小姐'
          ]
        }
      ],
      xinan: [
        {
          name: '西南区域',
          child: [
            '重庆：136 3775 6600 张先生',
            '成都：136 1832 7887 夏先生',
            '贵州：136 3778 2729 熊先生',
            '西安：133 7263 1233 夏先生'
          ]
        },
        {
          name: '海外区域',
          child: [
            // "德国：138 2691 8861 罗先生",
            // "137 9489 1514 宋先生",
            '外贸：139 2580 4679 李小姐',
            // "邮箱：sales2@hlx-conveyor.com"
            '邮箱：lisf@huixinggroup.com'
          ]
        }
      ],
      huadong: [
        {
          name: '浙江区域',
          child: ['宁波：139 5783 7388 张先生', '杭州：139 5783 7188 何小姐']
        },
        {
          name: '华东区域',
          child: [
            '昆山：133 9087 7816 钟先生',
            '苏州：138 6244 5332 曾小姐',
            '上海：133 9087 7836 张先生'
          ]
        }
      ],
      huabei: [
        {
          name: '华北区域',
          child: ['华北：176 7788 8088 胡先生']
        },
        {
          name: '闽厦区域',
          child: ['厦门：185 0695 5108 廖先生', '福州：185 0695 5109 钟小姐']
        },
        {
          name: '华中区域',
          child: [
            // "武汉:186 2789 8099 夏先生"
            '湖南：152 1504 7772 曾先生',
            '湖北：136 3778 2759 刘先生'
          ]
        }
      ],
      relationList: []
    };
  },
  mounted() {
    this.getRelationList()
  },
  methods: {
    elSelect(index) {
      this.listIndex = index;
      this.listValue = this.list[index].name;
    },
    getRelationList() {
      getRelation().then(res => {
        if (res.result) {
          const list = []
          res.data.forEach((item, index) => {
            if (index === 0) {
              list.push({ area: item.area, list: [item] })
            } else {
              const hasId = list.findIndex((it) => it.area === item.area)
              if (hasId !== -1) {
                list[hasId].list.push(item)
              } else {
                list.push({ area: item.area, list: [item] })
              }
            }
          })
          this.relationList = list
          console.log('list', list)
        }
      })
    }
  }
};
</script>

<style scoped="scoped">
.relationList {
  height: 180px;
  flex: 1;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
}

.relation {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.relationArea {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1rem;
  color: #fff;
  line-height: 1rem;
}

.relationArea img {
  width: 1rem;
  display: inline-block;
}

.relationItem {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  font-size: .8rem;
  color: #d8e5f2;
  cursor: pointer;
}

.relationItem p:hover {
  color: #004193;
}



.top-box {
  /* padding: 30px 0; */
  justify-content: space-between;
  align-items: flex-start;
}

.pull-left {
  width: 80%;
  display: flex;
  color: #ffffff;
}

.el-select {
  width: 100%;
}

.lists {
  width: 30%;
  /* margin-top: 20px; */
}

.lists p {
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 10px;
  color: #d8e5f2;
  font-size: 0.8rem;
}

.lists p:hover {
  color: #004193;
}

.address-box img {
  width: 1rem;
}
.address-box span {
  color: #ffffff;
  font-size: 1rem;
}

/deep/ .el-input__inner {
  background-color: rgba(255, 255, 255, 0.5);
}

/deep/ .el-select .el-input.is-focus .el-input__inner,
/deep/ .el-select .el-input__inner:focus {
  border: none;
}

/deep/ .el-select .el-input .el-select__caret {
  color: #333;
}

.box-right {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 20%;
}
.box-right .box1 {
  margin: 0 auto;
  width: 17.5rem;
}

.box-right .box1 span {
  display: block;
  font-size: 1rem;
  padding-left: 23px;
  /* margin-top: 0.875rem; */
  background: url(../assets/images/icon_9.png) no-repeat left;
  background-size: 18px;
}

.box-right .box1 i {
  display: block;
  font-size: 1.375rem;
  font-weight: bold;
  margin: 0 0 0.3125rem;
  color: #fff;
}

.box-right .pull-right {
  display: flex;
  margin-top: 0.9rem;
}
.box-right .pull-right .label {
  margin-top: 0.3rem;
  font-size: 0.95rem;
}
.box-right .pull-right .box2 {
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dkhs-box {
  padding-top: 50px;
}

.dkhs-box li {
  display: flex;
  align-items: center;
  width: 20%;
}

.dkhs-box li .right {
  margin-left: 0.8rem;
}

.dkhs-box li .description {
  color: #ffffff;
  font-size: 1rem;
}

.dkhs-box li .labels {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: bold;
}

.dkhs-box li img {
  width: 77px;
  margin-right: 10px;
  font-size: 0.58rem;
}

.dkhs-box li p {
  line-height: 23px;
}

.address-box img {
  width: 1rem;
}

.circle {
  width: 75px;
  height: 75px;
  background: radial-gradient(
    circle,
    rgba(71, 141, 202, 0.8) 0%,
    rgba(71, 141, 202, 0.8) 35%,
    rgba(255, 255, 255, 0.3) 80%,
    transparent 100%
  );
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  font-family: AlibabaPuHuiTiH;
  font-weight: 600;
  font-size: 36px;
  color: #ffffff;
  margin-right: 0.5rem;
}

.text {
  white-space: nowrap;
}

.line {
  padding-bottom: 50px;
  border-bottom: 1px solid rgb(255, 255, 255, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue